import moment from 'moment-timezone';

export const DEFAULT_TIMEZONE = 'America/Sao_Paulo';
export const calendarDate = (value: unknown) => moment(value as moment.MomentInput).format('YYYY-MM-DD');
export const zonedDate = (value: moment.MomentInput, timezone?: string) =>
    moment(value).tz(timezone || DEFAULT_TIMEZONE);

/** Adaptador visual para controles que so aceitam Date no fuso do navegador. */
export const calendarDisplayDate = (value: moment.MomentInput, timezone?: string): Date => {
    const local = zonedDate(value, timezone);
    return new Date(local.year(), local.month(), local.date(), local.hour(), local.minute(), local.second());
};

/** Posicao no calendario visual, independente do DST do navegador. */
export const calendarMinuteOffset = (value: moment.MomentInput, day: string, timezone?: string): number => {
    const local = zonedDate(value, timezone);
    const days = moment.utc(local.format('YYYY-MM-DD')).diff(moment.utc(day), 'days');
    return days * 1440 + local.hour() * 60 + local.minute();
};

export const dateTimeErrorMessage = (code?: string): string | undefined => ({
    horarioLocalInexistente: 'Esse horário não existe nesta data devido à mudança de horário de verão. Escolha outro horário.',
    horarioLocalAmbiguo: 'Esse horário ocorre duas vezes nesta data devido à mudança de horário de verão. Escolha outro horário.',
    horarioLocalInconsistente: 'O horário enviado não corresponde ao fuso do estabelecimento. Atualize a agenda e escolha novamente.',
    dataHoraSemOffset: 'Atualize a agenda e escolha o horário novamente.',
} as Record<string, string>)[code || ''];
